/* EB homepage category Load More — LIVE + Funnel Build 2026-10-20.
   Vanilla JS. Each treated homepage category section renders a Load More
   button (snippets/include-featured-collection.liquid, gated by the section
   setting eb_load_more). Clicking fetches the section's collection pages in
   order, extracts the product cards (.product-thumbnail, rendered by the same
   product-loop/product-thumbnail snippets as the homepage grid, including the
   one-page quick-order block), and appends the next batch in place.
   Repeatable until the collection is exhausted; then the button hides.
   Newly appended cards are initialised by assets/eb-quick-order.js (its
   MutationObserver + event delegation) and by an explicit refreshAll call. */
(function () {
  'use strict';

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function extractCards(doc) {
    /* 2026-10-21 fix: extract ONLY from the collection page's product grid
       (.collection-matrix in sections/collection__main.liquid). The old
       scopes (.collection__content, then the whole document) could pull
       .product-thumbnail nodes from non-grid areas of the fetched page.
       Fail closed: no grid on the page means no cards, never substitutes. */
    var grid = doc.querySelector('.collection-matrix');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('.product-thumbnail'));
  }

  /* The theme's lazy loader (img.lazy2, real URL in data-src2 /
     data-mobsrc2) never observes cards cloned from a fetched page, so
     appended cards rendered as text + review badges with no image.
     Force-load every image in a card before it enters the grid. */
  function forceLoadImages(card) {
    var mobile = window.matchMedia && window.matchMedia('(max-width: 799px)').matches;
    card.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('data-src2');
      var mob = img.getAttribute('data-mobsrc2');
      if (mobile && mob) src = mob;
      if (src) img.setAttribute('src', src);
      img.classList.remove('lazyload');
      img.classList.remove('lazy2');
      img.classList.add('lazyloaded');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-eb-load-more]') : null;
    if (!btn || btn.disabled) return;

    var actions = btn.closest('[data-eb-cat-actions]');
    var sectionWrap = btn.closest('.shopify-section') || (actions && actions.closest('section'));
    if (!sectionWrap) return;
    var grid = sectionWrap.querySelector('.featured-collection');
    if (!grid) return;

    var handle = btn.getAttribute('data-handle');
    var batch = parseInt(btn.getAttribute('data-batch'), 10) || 8;
    var total = parseInt(btn.getAttribute('data-total'), 10) || 0;

    var state = btn._ebState || (btn._ebState = {
      buffer: [],
      nextPage: 1,
      exhausted: false,
      seen: {}
    });

    /* Handles already on the page (initial grid + prior appends). */
    var existing = grid.querySelectorAll('.product-thumbnail');
    existing.forEach(function (card) {
      var h = handleOf(card);
      if (h) state.seen[h] = true;
    });
    var shown = existing.length;
    var firstCardClass = existing.length ? existing[0].className : null;

    function finish(appended) {
      btn.disabled = false;
      btn.textContent = 'Load More';
      window.dispatchEvent(new Event('resize'));
      if (window.EBQuickOrder) window.EBQuickOrder.refreshAll(sectionWrap);
      if (appended === 0 || shown + appended >= total || state.exhausted && state.buffer.length === 0) {
        btn.hidden = true;
      }
    }

    function appendBatch() {
      var n = 0;
      while (state.buffer.length && n < batch) {
        var card = state.buffer.shift();
        if (firstCardClass) card.className = firstCardClass;
        forceLoadImages(card);
        grid.appendChild(card);
        n++;
      }
      finish(n);
    }

    function fetchNext() {
      if (state.exhausted) { appendBatch(); return; }
      btn.disabled = true;
      btn.textContent = 'Loading\u2026';
      fetch('/collections/' + handle + '?page=' + state.nextPage, {
        headers: { 'Accept': 'text/html' }
      }).then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = extractCards(doc);
          var fresh = 0;
          cards.forEach(function (card) {
            var h = handleOf(card);
            if (h && !state.seen[h]) {
              state.seen[h] = true;
              state.buffer.push(card);
              fresh++;
            }
          });
          state.nextPage++;
          if (!cards.length || fresh === 0) state.exhausted = true;
          if (state.buffer.length >= batch || state.exhausted) {
            appendBatch();
          } else {
            fetchNext();
          }
        })
        .catch(function () {
          state.exhausted = true;
          appendBatch();
        });
    }

    if (state.buffer.length >= batch) {
      appendBatch();
    } else {
      fetchNext();
    }
  });
})();
